@if (guidanceMaterial) {
    @if (guidanceMaterial.locationUrl) {
        <a [attr.href]="getAbsoluteUrl(guidanceMaterial.locationUrl)"
           target="_blank"
           rel="noreferrer noopener">{{ guidanceMaterial.name }}</a>
    } @else {
        <span>{{ guidanceMaterial.name }}</span>
    }
    @if (showDescription && guidanceMaterial.description) {
        <div [froalaView]="guidanceMaterial.description"></div>
    }
}
